import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-BJEvNVLM.js';
import { b as bem } from './p-g1JgJ7wn.js';
import { t as transformTagName } from './p-CkrRd9Ud.js';
import { d as defineCustomElement$5 } from './p-DJyNTNX7.js';
import { d as defineCustomElement$4 } from './p-G9l7h4A8.js';
import { d as defineCustomElement$3 } from './p-ODoCtssu.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosOptionCss = ":host{display:block;max-width:100%;position:relative;width:100%}:host(:focus){outline:none}:host(:focus)::before{content:\"\";border-radius:calc(2.66px * 1.5);bottom:calc((4px + -4px) * -1);box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + -4px) * -1);position:absolute;right:calc((4px + -4px) * -1);top:calc((4px + -4px) * -1)}.cosmos-option{align-items:center;border-radius:4px;box-sizing:border-box;cursor:default;display:flex;gap:6px;justify-content:space-between;margin:0;max-width:100%;padding:6px 8px;position:relative;-webkit-user-select:none;user-select:none;width:100%;--cosmos-text-color:var(--cosmos-option-color);--cosmos-text-font-family:var(--cosmos-option-font-family);--cosmos-text-font-size:var(--cosmos-option-font-size);--cosmos-text-font-style:var(--cosmos-option-font-style);--cosmos-text-font-weight:var(--cosmos-option-font-weight);--cosmos-text-letter-spacing:var(--cosmos-option-letter-spacing);--cosmos-text-line-height:var(--cosmos-option-line-height);--cosmos-text-text-transform:var(--cosmos-option-text-transform)}.cosmos-option__leading,.cosmos-option__trailing{align-items:center;display:flex;gap:var(--cosmos-option-gap, 6px);max-width:fit-content;min-width:0}.cosmos-option__leading{flex-grow:1;max-width:100%}.cosmos-option__label{flex-grow:1}.cosmos-option__icon{--cosmos-icon-color:#000F1E;align-content:center;flex:0 0 auto;height:18px;width:18px}.cosmos-option__checkbox{width:18px}.cosmos-option__meta{--cosmos-text-font-family:var(--cosmos-option-meta-font-family);--cosmos-text-font-size:var(--cosmos-option-meta-font-size);--cosmos-text-font-style:var(--cosmos-option-meta-font-style);--cosmos-text-font-weight:var(--cosmos-option-meta-font-weight)}.cosmos-option--selected{background-color:var(--cosmos-option-background-color-selected, rgba(0, 15, 30, 0.05))}.cosmos-option--disabled{--cosmos-text-color:rgba(0, 15, 30, 0.45)}.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(0, 15, 30, 0.45)}.cosmos-option:hover:not(.cosmos-option--disabled){background-color:var(--cosmos-option-background-color-hover, rgba(0, 15, 30, 0.05))}.cosmos-option--appearance-light .cosmos-option__icon{--cosmos-icon-color:#FFFFFF}.cosmos-option--appearance-light.cosmos-option--disabled{--cosmos-text-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light.cosmos-option--disabled .cosmos-option__icon{--cosmos-icon-color:rgba(255, 255, 255, 0.45)}.cosmos-option--appearance-light:hover:not(.cosmos-option--disabled){background-color:var(--cosmos-option-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-option--appearance-light.cosmos-option--selected{background-color:var(--cosmos-option-background-color-selected, rgba(255, 255, 255, 0.1))}.cosmos-option ::slotted([slot=prefix]){flex:0 0 auto;--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}";

const generateClassNames = bem('cosmos-option');
const CosmosOption$1 = /*@__PURE__*/ proxyCustomElement(class CosmosOption extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.optionselectEvent = createEvent(this, "optionselect", 7);
        /**
         * The appearance of the Option. It allows the component to adapt to dark or light environments.
         */
        this.appearance = 'dark';
        /**
         * Marks the option as disabled
         */
        this.disabled = false;
        /**
         * The meta information text of the Option.
         */
        this.meta = '';
        /**
         * Marks the option as selected and displays an icon as visual indicator.
         */
        this.selected = false;
        /**
         * The value of the Option. It is submitted with the parent form as part of a name/value pair.
         */
        this.value = '';
        this.showCheckbox = false;
        this.handleMouseDown = (event) => {
            // Prevent focus movement when clicking options with mouse
            // This ensures focus stays on combobox/search input
            event.preventDefault();
        };
    }
    clickHandler() {
        if (this.disabled) {
            return;
        }
        this.optionselectEvent.emit({ value: this.value });
    }
    composeTitle() {
        var _a;
        const label = (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim();
        if (this.meta) {
            return `${label} • ${this.meta}`;
        }
        return label;
    }
    componentWillLoad() {
        const closestSelect = this.element.closest(transformTagName('cosmos-select'));
        if (closestSelect === null || closestSelect === void 0 ? void 0 : closestSelect.hasAttribute('multiple')) {
            this.showCheckbox = true;
        }
    }
    render() {
        var _a;
        return (h(Host, { key: '75fb1dd5cfab9d821b8a660fba5f62c0c105d0c7', role: "option", "aria-label": (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim(), "aria-selected": this.selected.toString(), "aria-disabled": this.disabled ? 'true' : undefined, onMouseDown: this.handleMouseDown }, h("div", { key: '913ce657256b7f80911f7d78ff0ea957a695830b', class: generateClassNames({
                disabled: this.disabled,
                appearance: this.appearance,
                selected: this.selected,
            }), part: "base" }, h("div", { key: 'e8ff95e9d04ae29d6b30883eb560edc10443bff6', title: this.composeTitle(), class: `${generateClassNames('leading')}` }, this.showCheckbox && (h("cosmos-checkbox", { key: '24d2657e842b3a28756f03242718931f036aa86e', appearance: this.appearance, checked: this.selected, class: generateClassNames('checkbox'), tabIndex: -1 })), h("slot", { key: 'ae86bbf5cb27851ab019d943ec884290f614f0b1', "aria-hidden": "true", name: "prefix" }), h("cosmos-text", { key: '1aa1b846a8ef96c628f9c54662d7d4ff91f54937', appearance: this.appearance, exportparts: "base: label", class: generateClassNames('label'), size: "small", clamp: 1 }, h("span", { key: '49292789d2e9c179044109ace8ef61a9dccba3de' }, h("slot", { key: '74819fc083750172e8cd5cbf413f2205b49e9ffa' })))), h("div", { key: '8346be588ec04d2f2bc2479701c5975a0f06f274', class: generateClassNames('trailing') }, this.meta && (h("cosmos-text", { key: 'a688e411d9fe332a7164b10d698b70959ea7f91d', kind: "subtle", appearance: this.appearance, class: generateClassNames('meta'), clamp: 1, size: "x-small" }, this.meta)), this.selected && !this.showCheckbox && (h("cosmos-icon-checkmark", { key: 'dd30119370bf040c5792cd3ab0e571ae2727e2fc', class: generateClassNames('icon') }))))));
    }
    get element() { return this; }
    static get style() { return cosmosOptionCss; }
}, [1, "cosmos-option", {
        "appearance": [513],
        "disabled": [516],
        "meta": [513],
        "selected": [516],
        "value": [513],
        "showCheckbox": [32]
    }, [[0, "click", "clickHandler"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-option", "cosmos-checkbox", "cosmos-icon-checkmark", "cosmos-icon-warning", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-option":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosOption$1);
            }
            break;
        case "cosmos-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosOption = CosmosOption$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosOption, defineCustomElement };
